/* METADATA */
export const GAME_NAME = "unblind-test";

/* CONFIGS */
export const CATEGORIES = ['Toute Génération', 'Films et séries', 'Années 80', 'Disney', 'Rock']
export const URL_SONGS = "songs.json"
export const SONG_URL = "/songs/"

/* USER INTERFACE */
export const ICON_SIZE = "8rem";